var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"6","width":"18","height":"2","rx":"1","fill":"black","key":0}),React.createElement("rect",{"x":"3","y":"11","width":"18","height":"2","rx":"1","fill":"black","key":1}),React.createElement("rect",{"x":"3","y":"16","width":"18","height":"2","rx":"1","fill":"black","key":2})]);
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
